import React, { Component } from 'react'
import moment from 'moment'

export default class errorScreeningPopUp extends Component {
    render() {
        return (
            <div className='user_popup active'>
            <span className="popup_overlay" onClick={this.props.errorMsgPopup}></span>
            <div className="sundance_popup_detail box_shadow screening_error_popup bg_white">
                <div className="table_content bg_td_table">
                    <div className="table_wrap">
                        <table>
                            <tr>
                                <th>StartDate - EndDate</th>
                                <th>Error Msg</th>
                            </tr>
                            {this.props.errorMsg.map(item =>
                                <tr className='bg_color'>
                                    {console.log(item,"item")}
                                    <td><span>{moment(item.date).format('MMM DD - h:mm A')} - </span> <span>{moment(item.endDate).format('MMM DD - h:mm A')}</span></td>
                                    <td>{item.error}</td>
                                </tr>
                            )}
                            {/* <tr>
                            <td>christine_conell@sundance.org</td>
                            <td>Peter First Name</td>
                            <td>Sanchez First Name</td>
                            <td>General First Name</td>
                        </tr> 
                        <tr>
                            <td>christine_conell@sundance.org</td>
                            <td>Peter First Name</td>
                            <td>Sanchez First Name</td>
                            <td>General First Name</td>
                        </tr> */}
                        </table>
                    </div>
                </div>
                <div className="content">
                    <div className="field_row text_center">
                        <button className="small_btn active" onClick={this.props.errorMsgPopup}>OK</button>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}